import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const helpCenterSettingsAgentStudioChatSimulatorRoute: InvariantJiraRoute = {
	name: 'helpcenter-settings-agent-studio-chat-simulator',
	path: '/jira/helpcenter/projects/:projectKey/settings/:helpCenterId/agent/simulator',
	exact: true,
};
